module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_04-be56a326cd1c6a867e2e7df035cb9897.jpg";